import { GENDER_LABELS } from '@kit/shared/gender';

/**
 * Booklet / XLSX gender-label formatter for the offering-data readers (the M8
 * XLSX export and P8 PDF scholarship booklet).
 *
 * It reuses the canonical labels (`@kit/shared/gender`) for `male`/`female` so
 * those can never drift, and DELIBERATELY overrides `nonBinary` with the
 * German-market booklet term **'Diverse'** ("divers", the legal third-gender
 * label organizers expect in scholarship booklets). This single override is
 * intentional export localization — documented here so it is not mistaken for
 * the drift Critical Rule #8 guards against. Unknown values pass through;
 * null/undefined/empty yields ''.
 */
const BOOKLET_GENDER_LABELS: Record<string, string> = {
  ...GENDER_LABELS,
  nonBinary: 'Diverse',
};

export function formatGenderLabel(gender: string | null | undefined): string {
  if (!gender) return '';
  return BOOKLET_GENDER_LABELS[gender] ?? gender;
}
